export function format(seconds: number) {
  const date = new Date(seconds * 1000);
  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes().toString().padStart(2, "0");
  const ss = date.getUTCSeconds().toString().padStart(2, "0");

  if (hh) {
    return `${hh}:${mm}:${ss}`;
  }

  return `${mm}:${ss}`;
}

export function getDisplayRemainingMinutesAndSeconds(seconds: number) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds) % 60;

  if (minutes > 0) {
    return `${minutes} min ${remainingSeconds} s remaining`;
  }

  return `${remainingSeconds} s remaining`;
}

export function getWPM(playbackRate: number) {
  return playbackRate * 200;
}
